// Renderizador de markdown enxuto pras respostas da Sofia (chat).
// A Sofia responde em markdown padrão (títulos, **negrito**, listas, tabelas, > citações,
// `código`). Aqui viramos isso em HTML formatado e legível dentro do balão estreito do chat.
// Tabelas ficam num container rolável (.sofia-table) pra não espremer a tela.

function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

function inline(text: string): string {
  let s = escapeHtml(text)
  // negrito **texto** (antes do itálico)
  s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
  // itálico *texto* (evita pegar ** que já viraram strong)
  s = s.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>')
  // código `texto`
  s = s.replace(/`([^`]+)`/g, '<code>$1</code>')
  // links [texto](url) — externos abrem em nova aba; #artigo abre a Central de Ajuda
  s = s.replace(/\[([^\]]+)\]\(#([^)]+)\)/g, (_m, txt, id) =>
    `<a data-art="${id}" onclick="window.dispatchEvent(new CustomEvent('open-help-art',{detail:'${id}'}))">${txt}</a>`)
  s = s.replace(/\[([^\]]+)\]\((https?:[^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
  return s
}

export function renderSofiaMarkdown(md: string): string {
  const lines = md.replace(/\r\n/g, '\n').split('\n')
  const out: string[] = []
  let i = 0
  let inCode = false
  let codeBuf: string[] = []

  while (i < lines.length) {
    const line = lines[i]

    // Bloco de código ```
    if (line.trimStart().startsWith('```')) {
      if (!inCode) { inCode = true; codeBuf = [] }
      else { out.push(`<pre><code>${escapeHtml(codeBuf.join('\n'))}</code></pre>`); inCode = false }
      i++; continue
    }
    if (inCode) { codeBuf.push(line); i++; continue }

    // Tabela: linha com | e a próxima sendo o separador |---|---|
    if (line.trim().startsWith('|') && i + 1 < lines.length && /^\s*\|?[\s:|-]+\|[\s:|-]*$/.test(lines[i + 1]) && lines[i + 1].includes('-')) {
      const cells = (l: string) => l.replace(/^\s*\|/, '').replace(/\|\s*$/, '').split('|').map(c => c.trim())
      const header = cells(line)
      i += 2
      const rows: string[][] = []
      while (i < lines.length && lines[i].trim().startsWith('|')) { rows.push(cells(lines[i])); i++ }
      let t = '<div class="sofia-table"><table><thead><tr>'
      t += header.map(c => `<th>${inline(c)}</th>`).join('') + '</tr></thead><tbody>'
      t += rows.map(r => '<tr>' + r.map(c => `<td>${inline(c)}</td>`).join('') + '</tr>').join('')
      t += '</tbody></table></div>'
      out.push(t); continue
    }

    // Títulos (no chat tudo vira pequeno: h4/h5)
    const h = line.match(/^(#{1,6})\s+(.*)$/)
    if (h) {
      const lvl = h[1].length <= 3 ? 4 : 5
      out.push(`<h${lvl}>${inline(h[2])}</h${lvl}>`); i++; continue
    }

    // Citação >
    if (/^\s*>\s?/.test(line)) {
      const buf: string[] = []
      while (i < lines.length && /^\s*>\s?/.test(lines[i])) { buf.push(lines[i].replace(/^\s*>\s?/, '')); i++ }
      out.push(`<blockquote>${buf.map(inline).join('<br>')}</blockquote>`); continue
    }

    // Lista não ordenada
    if (/^\s*[-*]\s+/.test(line)) {
      const items: string[] = []
      while (i < lines.length && /^\s*[-*]\s+/.test(lines[i])) { items.push(lines[i].replace(/^\s*[-*]\s+/, '')); i++ }
      out.push('<ul>' + items.map(it => `<li>${inline(it)}</li>`).join('') + '</ul>'); continue
    }

    // Lista ordenada
    if (/^\s*\d+[.)]\s+/.test(line)) {
      const items: string[] = []
      while (i < lines.length && /^\s*\d+[.)]\s+/.test(lines[i])) { items.push(lines[i].replace(/^\s*\d+[.)]\s+/, '')); i++ }
      out.push('<ol>' + items.map(it => `<li>${inline(it)}</li>`).join('') + '</ol>'); continue
    }

    // Linha em branco
    if (line.trim() === '') { i++; continue }

    // Parágrafo — agrupa linhas seguidas
    const buf: string[] = []
    while (i < lines.length && lines[i].trim() !== '' && !/^(\s*[-*]\s+|\s*\d+[.)]\s+|#{1,6}\s+|\s*>\s?|```)/.test(lines[i]) && !lines[i].trim().startsWith('|')) {
      buf.push(lines[i]); i++
    }
    if (buf.length) out.push(`<p>${buf.map(inline).join('<br>')}</p>`)
  }

  if (inCode && codeBuf.length) out.push(`<pre><code>${escapeHtml(codeBuf.join('\n'))}</code></pre>`)
  return out.join('')
}
